import { TextArea, TextAreaProps, Layer } from '@carbon/react';
import classNames from 'classnames';
import style from './text-area-field.module.scss';

interface TextAreaFieldProps extends Omit<
  TextAreaProps,
  'value' | 'onChange' | 'light'
> {
  value: string | null | undefined;
  onChange: (value: string) => void;
  onBlur?: () => void;
  invalid?: boolean;
  invalidText?: string;
  required?: boolean;
  light?: boolean;
}

export function TextAreaField({
  value,
  onChange,
  onBlur,
  invalid,
  invalidText,
  required,
  labelText,
  light,
  ...rest
}: TextAreaFieldProps) {
  const textArea = (
    <TextArea
      labelText={
        labelText ? (
          <label>
            {labelText}
            {required && <span className={style.required}> (Required)</span>}
          </label>
        ) : undefined
      }
      value={value || ''}
      onChange={({ target: { value } }) => onChange(value)}
      onBlur={onBlur}
      invalid={invalid}
      invalidText={invalid ? invalidText : ''}
      {...rest}
    />
  );

  return (
    <div className={classNames({ [style.light]: light })}>
      {light ? <Layer>{textArea}</Layer> : textArea}
    </div>
  );
}
